module.exports = __webpack_public_path__ + "static/media/bg-white-kinedu-educators-pt.24920083.svg";